import * as React from "react";

interface FormFieldProps {
  label: string;
}

export const Field: React.FunctionComponent<FormFieldProps> = (props) => {
  return (
    <div className="form-group row">
      <label className="col-sm-2 col-form-label">{props.label}</label>
      <div className="col-sm-10">
        {props.children}
      </div>
    </div>
  )
}

interface InputFieldProps extends FormFieldProps {
  type: string;
  name: string;
  invalid?: boolean;
  value: string;
  feedback?: string;
  placeholder: string;
  autoFocus?: boolean;
  onChange: (e: any) => void;
  disabled?: boolean;
  autoComplete?: string;
}

export const InputField: React.FunctionComponent<InputFieldProps> = (props) => {
  return (
    <Field {...props}>
      <input
        type={props.type}
        name={props.name}
        className={`form-control ${props.invalid ? 'is-invalid' : null}`}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        disabled={props.disabled || false}
        autoFocus={props.autoFocus ? true : false}
        autoComplete={props.autoComplete} />
      <div className="invalid-feedback">{props.feedback}</div>
    </Field>
  )
}

interface DropDownField extends FormFieldProps {
  name: string;
  value: string;
  onChange: (e: any) => void;
  disabled?: boolean;
}

export const DropDownField: React.FunctionComponent<DropDownField> = (props) => {
  return (
    <Field label={props.label}>
      <select
        name={props.name}
        value={props.value}
        className="form-control"
        onChange={props.onChange}
        disabled={props.disabled}
      >
        {props.children}
      </select>
    </Field>
  )
}

export interface ValidatedField<T> {
  value: T,
  isValid: boolean,
  message: string,
}
